import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';
import swal from "sweetalert";
import { useSelector } from 'react-redux';
import useInputForm from '../../components/CustonHooks/FormHook';
import { userProfileService } from '../../services/backoffice/userProfile.service';
import { balanceService } from '../../services/control/balance.service';
import { CSVExporterTypes } from '../../enums/CSVExporterTypes';

export function BulkBalance(props) {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ multiple: true });
    const [isLoading, setIsLoading] = useState(false);
    const [view, setView] = useState("upload");
    const [results, setResults] = useState([]);

    const handleCsv = async (orderBy = '') => {
        const ascending = true;
        try {
            await userProfileService.downloadUsersCSV(orderBy, CSVExporterTypes.BALANCE, ascending);
        } catch (error) {
            console.error('CSV download failed:', error);
            swal("Error", "No fue posible descargar el archivo", "error");
        }
    };

   const parseErrorMessageToList = (msg) => {
    if (!msg) return [];

    const lines = msg
        .split(/\r?\n/)
        .map(l => l.trim())
        .filter(l => l.length > 0);

    const filtered = lines.filter(line => {
        if (/^se procesaron\s+\d+/i.test(line)) return false;
        if (/^errores?:\s*\d+$/i.test(line)) return false;
        if (/^[0-9]+$/.test(line)) return false;
        if (line.length < 3) return false;
        return true;
    });

    return filtered.map(line => {
        const lower = line.toLowerCase();

        const userMatch = line.match(/Usuario\s+(\d+)/i);
        const folioMatch = line.match(/folio\/referencia\s*=\s*([^ \n:]+)/i) ||
                           line.match(/folio\s*=\s*([^ \n:]+)/i) ||
                           line.match(/referencia\s*=\s*([^ \n:]+)/i);

        if (/^las siguientes/i.test(lower) || /^las siguientes imágenes/i.test(lower) || /^las siguientes imagen(es)?/i.test(lower)) {
            return {
                raw: line,
                userId: userMatch ? userMatch[1] : null,
                folio: folioMatch ? folioMatch[1] : null,
                reason: line,
                status: "error"
            };
        }

        let reason = line;
        const reasonSplit = line.split(":");
        if (reasonSplit.length > 1) {
            reason = reasonSplit.slice(1).join(":").trim();
        } else {
            reason = line;
        }

        return {
            raw: line,
            userId: userMatch ? userMatch[1] : null,
            folio: folioMatch ? folioMatch[1] : null,
            reason: reason,
            status: "error"
        };
    });
};

    const mapSuccessDataToList = (dataArray) => {
        if (!Array.isArray(dataArray)) return [];
        return dataArray.map(item => {
            const userId = item.userReceiveId || item.userId || item.user || null;
            const folio = item.folio || item.reference || null;
            const reason = item.validationMessage || "Correcto";
            return {
                raw: item,
                userId: userId,
                folio: folio,
                reason: reason,
                status: "success"
            };
        });
    };

    const upload = async () => {
        if (acceptedFiles.length === 0) {
            swal({ text: "Debes cargar un archivo para continuar", icon: "warning" });
            return;
        }

        setIsLoading(true);

        try {
            const result = await balanceService.uploadBulkBalance(acceptedFiles);
            console.log("upload result:", result);

            const responseMessage = result?.responseMessage || result?.data?.responseMessage || null;
            const rawDataArray = Array.isArray(result?.data) ? result.data : (Array.isArray(result) ? result : null);

            const successList = mapSuccessDataToList(rawDataArray || []);
            const errorList = parseErrorMessageToList(responseMessage);
            const combined = [...successList, ...errorList];

            if (!combined.length && responseMessage) {
                const parsedFallback = parseErrorMessageToList(responseMessage);
                if (parsedFallback.length) {
                    setResults(parsedFallback);
                } else {
                    setResults([{ raw: responseMessage, userId: null, folio: null, reason: responseMessage, status: "error" }]);
                }
            } else {
                setResults(combined);
            }

            setView("results");

            const successCount = combined.filter(r => r.status === "success").length;
            const errorCount = combined.filter(r => r.status === "error").length;
            const total = combined.length;

            if (errorCount > 0) {
                swal({ text: `Se procesaron ${total} registros. ${errorCount} con errores.`, icon: "warning" });
            } else {
                swal({ text: `Se procesaron ${total} registros. Todos correctos.`, icon: "success" });
            }

        } catch (error) {
            console.error("Upload exception:", error);
            const serverMsg =
                error?.response?.data?.responseMessage ||
                error?.response?.data?.message ||
                error?.response?.data ||
                error?.message ||
                JSON.stringify(error);

            const parsedErrors = parseErrorMessageToList(serverMsg);
            if (parsedErrors.length) {
                setResults(parsedErrors);
            } else {
                setResults([{ raw: serverMsg, userId: null, folio: null, reason: serverMsg, status: "error" }]);
            }
            setView("results");
        } finally {
            setIsLoading(false);
        }
    };

    const files = acceptedFiles.map((file, idx) => (
        <li key={file.path ? file.path + idx : file.name + idx}>{file.path || file.name} - {file.size} bytes</li>
    ));

    const totals = {
        total: results.length,
        success: results.filter(r => r.status === "success").length,
        error: results.filter(r => r.status === "error").length
    };

    return (
        <div className="wrapper_details_balance card shadows p-4">
            {view === "upload" && (
                <form>
                    <fieldset>
                        <legend className="text fnt_medium">{props.status == 1 ? "Solicitar " : "Asignar "}Saldo</legend>
                        <h5>Descarga la lista de usuarios</h5>
                        <button
                            type="button"
                            className="btn primary minimum"
                            onClick={(e) => { e.preventDefault(); handleCsv(); }}
                        >
                            <i className="far fa-file-excel"></i>{" "}Generar template de carga
                        </button>

                        <hr />
                        <h5>Carga de archivo y comprobantes</h5>
                        <div className="wrapper_dropzone">
                            <div {...getRootProps({ className: 'dropzone shadows bradius' })}>
                                <input {...getInputProps()} accept=".csv, .png, .jpg, .jpeg" />
                                <div className="box_dropzone">
                                    <span><i className="fas fa-download"></i></span>
                                    <p>Arrastre y suelte un archivo .csv aquí, también añada las imágenes que usará como referencia, o haga clic para seleccionar un archivo.</p>
                                    <strong>Las imágenes deberán tener el mismo nombre que su folio o referencia</strong>
                                </div>
                            </div>
                            <aside className="mt-4">
                                <h5 className="text fnt_medium">Archivo seleccionado:</h5>
                                <ul>{files}</ul>
                            </aside>
                        </div>
                        <hr />
                        <div className="text-right">
                            <button
                                type="button"
                                onClick={(e) => { e.preventDefault(); upload(); }}
                                className="btn primary"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Procesando...' : 'Subir archivo'}
                            </button>
                        </div>
                    </fieldset>
                </form>
            )}

            {view === "results" && (
                <div className="results-table mt-4">
                    <h5>Resultados de la carga</h5>

                    <div className="mb-3">
                        <strong>Total:</strong> {totals.total} &nbsp;|&nbsp;
                        <span style={{ color: 'green' }}><strong>Correctos:</strong> {totals.success}</span> &nbsp;|&nbsp;
                        <span style={{ color: 'red' }}><strong>Errores:</strong> {totals.error}</span>
                    </div>

                    {results.length === 0 ? (
                        <p>No hay resultados para mostrar.</p>
                    ) : (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Usuario</th>
                                    <th style={{ width: '20%' }}>Folio/Referencia</th>
                                    <th>Descripción</th>
                                    <th style={{ width: '10%' }}>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.map((r, idx) => (
                                    <tr key={idx} className={r.status === "error" ? "table-danger" : "table-success"}>
                                        <td>{r.userId ?? '-'}</td>
                                        <td>{r.folio ?? '-'}</td>
                                        <td style={{ whiteSpace: 'pre-wrap' }}>{r.reason ?? (typeof r.raw === 'string' ? r.raw : JSON.stringify(r.raw))}</td>
                                        <td>{r.status === "error" ? "Error" : "Correcto"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <div className="mt-3">
                        <button
                            className="btn secundary mr-2"
                            onClick={() => { setView("upload"); setResults([]); }}
                        >
                            Cargar otro archivo
                        </button>

                        <button
                            className="btn primary mr-2"
                            onClick={() => {
                                window.location.href = "/balance";
                            }}
                        >
                            Ir a listado de saldos
                        </button>
                    </div>
                </div>
            )}

            {view === "success" && (
                <div className="mt-4">
                    <h4>¡Datos guardados correctamente!</h4>
                    <button className="btn primary mt-3" onClick={() => setView("upload")}>
                        Cargar nuevo archivo
                    </button>
                </div>
            )}

            {view !== "results" && (
                <div className="mt-3">
                    <Link className="btn secundary minimum ml-1 mr-1" to="/balance">Regresar</Link>
                </div>
            )}
        </div>
    );
}
